import { selectTheme } from '@/store/selectors/ThemeSelector'
import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'
import { CssBaseline, GlobalStyles } from '@mui/material'
import {
  ThemeProvider as MUIThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles'
import { ReactNode, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import globalStyles from './globalStyles'
import { createCustomTheme } from './theme'
import { MODE_TYPE } from './types/constants'
import { injectThemeCSSVariables } from './themeToCSS'

interface ThemeProviderProps {
  children: ReactNode
}
const cache = createCache({
  key: 'css',
  prepend: true,
})

export default function ThemeProvider({ children }: ThemeProviderProps) {
  const [palette, setPalette] = useState(MODE_TYPE.DARK_MODE)
  const themeMode = useSelector(selectTheme)

  const theme = createCustomTheme({
    palette: palette,
    mode: 'dark',
  })

  useEffect(() => {
    setPalette(themeMode)
    document.documentElement.setAttribute('data-theme', themeMode)
    injectThemeCSSVariables(theme, themeMode as 'light' | 'dark')
  }, [themeMode, theme])

  return (
    <CacheProvider value={cache}>
      <StyledEngineProvider injectFirst>
        <MUIThemeProvider theme={theme}>
          <CssBaseline />
          <GlobalStyles styles={globalStyles} />
          {children}
        </MUIThemeProvider>
      </StyledEngineProvider>
    </CacheProvider>
  )
}
